import React from "react";
import { FormGroup, Label, Card, CardBody } from "reactstrap";

interface ObjectInputProps {
  label: string;
  value: Record<string, any>;
  onChange: (value: Record<string, any>) => void;
  fields: {
    key: string;
    label: string;
    type: string;
    options?: { label: string; value: string }[];
  }[];
}

const ObjectInput: React.FC<ObjectInputProps> = ({
  label,
  value,
  onChange,
  fields,
}) => {
  const handleChange = (key: string, newValue: any) => {
    onChange({
      ...value,
      [key]: newValue,
    });
  };

  return (
    <FormGroup>
      <Label className="fw-bold">{label}</Label>
      {fields.map((field) => (
        <FormGroup key={field.key}>
          <Label>{field.label}</Label>
          {field.type === "select" && field.options ? (
            <select
              className="form-select"
              value={value[field.key] || ""}
              onChange={(e) => handleChange(field.key, e.target.value)}
            >
              <option value="">Select...</option>
              {field.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          ) : field.type === "textarea" ? (
            <textarea
              className="form-control"
              value={value[field.key] || ""}
              onChange={(e) => handleChange(field.key, e.target.value)}
              rows={3}
            />
          ) : field.type === "checkbox" ? (
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={value[field.key] || false}
                onChange={(e) => handleChange(field.key, e.target.checked)}
              />
              <label className="form-check-label">{field.label}</label>
            </div>
          ) : (
            <input
              type={field.type}
              className="form-control"
              value={value[field.key] || ""}
              onChange={(e) => handleChange(field.key, e.target.value)}
            />
          )}
        </FormGroup>
      ))}
    </FormGroup>
  );
};

export default ObjectInput;
